
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { Contact, GroupUserExternal, IContact } from '../../../backend/backendapi';
import ContactStore from '../../../../stores/ContactStore';
import { emptyUUID, isValidEmail, vSelectInModalWithPopper } from '../../../../util';
import EmailModal from '../../../util/EmailModal';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export type SendEvent<T> = { context: T, contact: Contact | undefined, subject: string, html: string };

@Component({
  components: {
    EmailModal,
    vSelect,
  },
})
export default class EmailWithContactModal extends Vue {
  private readonly contactStore = new ContactStore();
  contact: Contact | null = null;
  groupUserExternal: GroupUserExternal | null = null;

  vSelectInModalWithPopper = vSelectInModalWithPopper;

  get contactFromGroupUserExternal(): Contact {
    return Contact.fromJS({
      id: emptyUUID(),
      firstName: this.groupUserExternal?.firstName,
      lastName: this.groupUserExternal?.lastName,
      email: this.groupUserExternal?.email,
    } as IContact);
  }

  get contacts(): any {
    return [this.contactFromGroupUserExternal, ...this.contactStore.contacts]
        .filter(e => isValidEmail(e.email))
        .map(e => ({ contact: e, label: `${e.firstName} ${e.lastName} (${e.email})` }));
  }

  mounted(): void {
    this.contactStore.loadIfAbsent();
  }

  public open(groupUserExternal: GroupUserExternal, title: string, content: string): void {
    this.groupUserExternal = groupUserExternal;
    this.contact = this.contactFromGroupUserExternal;
    (this.$refs.modal as EmailModal).open(groupUserExternal, title, content);
  }

  public dismiss(): void {
    (this.$refs.modal as EmailModal).dismiss();
  }
}
